import script from "./DatePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./DatePicker.vue?vue&type=script&setup=true&lang=js"

import "./DatePicker.vue?vue&type=style&index=0&id=05353793&lang=css"

const __exports__ = script;

export default __exports__